import { LocalAuth } from "@core/model/local-auth";
import { LocalFeatures } from "@core/model/local-features";
import { LocalProfile } from "@core/model/local-profile";

export class ApiToFormService {
  static MapLocalAuth(data: any): LocalAuth {
    const mappedData = {
      accessExpiry: data.access_exp,
      accessToken: data.access_token,
      refreshExpiry: data.refresh_exp,
      refreshToken: data.refresh_token,
      userCode: data.user_code,
      role: data.role,
    } as LocalAuth;

    return mappedData;
  }

  static MapProfile(data: any): LocalProfile {
    const mappedData = {
      code: data.code,
      name: `${data.last_name} ${data.first_name}`,
      roleId: data?.role,
      roleName: data?.role_name,
      username: data?.username,
    } as LocalProfile;
    return mappedData;
  }

  static MapClientFeatures(data: any): LocalFeatures {
    const mappedData = {
      featureQuota: Boolean(data.feature_quota),
      featureSplashScreen: Boolean(data.feature_splash_screen),
      featureCoupon: Boolean(data.feature_coupon),
      featureReferral: Boolean(data.feature_referral),
      featureFleetManagement: Boolean(data.feature_fleet_management),
      featureReceiptNotes: Boolean(data.feature_receipt_notes),
    } as LocalFeatures;
    return mappedData;
  }
}
